// extracted by mini-css-extract-plugin
module.exports = {"icon":"hey-pango-callout_icon__C7xjH","container":"hey-pango-callout_container__vpc2l"};